'use client'

import {
	qrNameFormConfig,
	TQrContentFormSection,
} from 'features/generator/contentFormSections'
import { wifiFormConfig } from 'features/generator/contentFormSections/WifiForm'
import { useTranslations } from 'next-intl'

import { ContentForm } from '../../ContentForm'
import { QR_TYPE, TContentFormProps } from '../../generatorTypes'

export const WifiContentForm = (props: TContentFormProps) => {
	const t = useTranslations()

	const config = {
		formSectionList: [
			wifiFormConfig(t),
			qrNameFormConfig(t),
		] satisfies TQrContentFormSection[],
	}

	return <ContentForm config={config} qrType={QR_TYPE.Wifi} {...props} />
}
